
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Lägg till på hemskärmen för att få en bättre användarupplevelse och enklare åtkomst.`,
's1b9047d53d9f9d22': `2) Tryck på Dela-knappen i verktygsfältet`,
's37a9e8aec5713460': `Mer`,
's5c6aad7a7e4a1437': `3) Välj Lägg till på hemskärmen`,
's6196153c4b0c1ea0': `Installera`,
's922329d6f6213590': `Lägg till i Dock`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sa7551383d1897fcc': `2) Välj Lägg till i Dock`,
'sba52286c21552a4e': `Installera den på din enhet för att få en bättre användarupplevelse och enklare åtkomst.`,
'sc79fd7641eb9a975': `Göm instruktioner`,
'scdaf4bbff76674c8': `Lägg till på hemskärmen`,
'sdfe23506a3b0cdc8': `1) Öppna i Safari`,
'se740f75b95a51807': `Lägg till i Dock för att få en bättre användarupplevelse och enklare åtkomst.`,
'sfea652f6580ff086': `Denna webbsajt har app-funktionalitet.`,
    };
  